import './SearchJobRedirect.scss'

import { useEffect, useState } from 'react'

import { getDataDmAttribute, pushRedirectAnalytics } from './analytics'
import { LocationDropdown } from './LocationDropdown'
import { SearchInput } from './SearchInput'
import { LocationItem, SearchJobRedirectProps } from './SearchJobRedirectProps'
import { buildSearchURL } from './utils'

export default function SearchJobRedirect({ locationdatavalue,
    joblisthashcodevalue,
    searchtextplaceholder,
    locationplaceholder,
    searchresultspage,
    buttonlabel,
    searchtitlelabel
   }: SearchJobRedirectProps) {
  const [searchText, setSearchText] = useState('')
  const [selectedLocations, setSelectedLocations] = useState<string[]>([])
  const [locations, setLocations] = useState<LocationItem[]>([])

  const searchTextPlaceholder = searchtextplaceholder || 'Search by job title or keyword'
  const locationPlaceholder = locationplaceholder || 'Location'
  const buttonLabel = buttonlabel || 'Find a Job'
  const searchTitleLabel = searchtitlelabel || 'Search for a Role'
  const redirectPath = searchresultspage || '/content/pg/www/en/careers/open-jobs.html'

  useEffect(() => {
    if (locationdatavalue) {
      try {
        const parsedData = typeof locationdatavalue === 'string' ? JSON.parse(locationdatavalue) : locationdatavalue

        if (Array.isArray(parsedData)) {
          setLocations(parsedData)
        } else {
          setLocations([])
        }
      } catch (error) {
        console.error('Failed to parse location data:', error)
        setLocations([])
      }
    } else {
      setLocations([])
    }
  }, [locationdatavalue])

  const handleSearch = () => {
    const finalUrl = buildSearchURL({
      searchText,
      selectedLocations,
      locations,
      redirectPath,
      hashCode: joblisthashcodevalue,
    })

    pushRedirectAnalytics(searchText, selectedLocations, finalUrl)

    window.location.href = finalUrl
  }

  const handleLocationApply = (locations: string[]) => {
    setSelectedLocations(locations)
  }

  return (
    <div className="cmp-search-job-redirect">
      {searchTitleLabel && (
        <h2 className="cmp-search-job-redirect__title">{searchTitleLabel}</h2>
      )}
      <div className="cmp-search-job-redirect__container">
        <SearchInput
          value={searchText}
          onChange={setSearchText}
          onSearch={handleSearch}
          placeholder={searchTextPlaceholder}
          dataDm={getDataDmAttribute('search')}
        />

        <LocationDropdown
          locations={locations}
          selectedLocations={selectedLocations}
          onApply={handleLocationApply}
          placeholder={locationPlaceholder}
          dataDm={getDataDmAttribute('location')}
        />

        <button
          className="cmp-search-job-redirect__search-button"
          onClick={handleSearch}
          aria-label={buttonLabel}
          type="button"
          data-dm={getDataDmAttribute('button')}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  )
}